import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: { padding: 30, fontFamily: 'Helvetica', fontSize: 10 },
  header: { backgroundColor: '#7B1FA2', color: '#ffffff', padding: 15, marginBottom: 20 },
  headerTitle: { fontSize: 18, fontWeight: 'bold' },
  headerSubtitle: { fontSize: 10, opacity: 0.9, marginTop: 4 },
  statsRow: { flexDirection: 'row', marginBottom: 20, gap: 10 },
  statBox: { flex: 1, border: '1px solid #e0e0e0', padding: 12, backgroundColor: '#f3e5f5', textAlign: 'center' },
  statValue: { fontSize: 20, fontWeight: 'bold', color: '#7B1FA2', marginBottom: 2 },
  statLabel: { fontSize: 8, color: '#666666' },
  section: { marginBottom: 20 },
  sectionTitle: { fontSize: 14, fontWeight: 'bold', backgroundColor: '#e1bee7', padding: 10, marginBottom: 10 },
  table: { marginBottom: 15 },
  tableHeader: { flexDirection: 'row', backgroundColor: '#f3e5f5', borderBottom: '2px solid #7B1FA2' },
  tableRow: { flexDirection: 'row', borderBottom: '1px solid #e0e0e0' },
  tableRowAlt: { flexDirection: 'row', borderBottom: '1px solid #e0e0e0', backgroundColor: '#fce4ec' },
  tableRowTop3: { flexDirection: 'row', borderBottom: '1px solid #e0e0e0', backgroundColor: '#fff9c4' },
  cell: { padding: 8 },
  cellRank: { width: 30, textAlign: 'center' },
  cellNombre: { width: 150 },
  cellNum: { width: 70, textAlign: 'center' },
  cellPeso: { width: 80, textAlign: 'right' },
  headerCell: { fontWeight: 'bold', fontSize: 9 },
  trophy: { fontSize: 12 },
  footer: { position: 'absolute', bottom: 30, left: 30, right: 30, borderTop: '1px solid #e0e0e0', paddingTop: 10, flexDirection: 'row', justifyContent: 'space-between', fontSize: 8, color: '#666666' },
});

const ReporteProductividadPDF = ({ data, filters }) => {
  const getRank = (idx) => {
    if (idx === 0) return '🥇';
    if (idx === 1) return '🥈';
    if (idx === 2) return '🥉';
    return `${idx + 1}`;
  };

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <Text style={styles.headerTitle}>Reporte de Productividad</Text>
          <Text style={styles.headerSubtitle}>
            Período: {filters.fecha_inicio} al {filters.fecha_fin}
          </Text>
        </View>

        <View style={styles.statsRow}>
          <View style={styles.statBox}>
            <Text style={styles.statValue}>{data.resumen.total_paletizadores}</Text>
            <Text style={styles.statLabel}>PALETIZADORES ACTIVOS</Text>
          </View>
          <View style={styles.statBox}>
            <Text style={styles.statValue}>{data.resumen.total_distribuidores}</Text>
            <Text style={styles.statLabel}>DISTRIBUIDORES ACTIVOS</Text>
          </View>
        </View>

        {/* Paletizadores */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>👷 Paletizadores</Text>
          <View style={styles.table}>
            <View style={styles.tableHeader}>
              <Text style={[styles.cell, styles.cellRank, styles.headerCell]}>#</Text>
              <Text style={[styles.cell, styles.cellNombre, styles.headerCell]}>NOMBRE</Text>
              <Text style={[styles.cell, styles.cellNum, styles.headerCell]}>PALLETS</Text>
              <Text style={[styles.cell, styles.cellNum, styles.headerCell]}>VUELOS</Text>
              <Text style={[styles.cell, styles.cellPeso, styles.headerCell]}>PESO (kg)</Text>
              <Text style={[styles.cell, styles.cellNum, styles.headerCell]}>PIEZAS</Text>
            </View>
            {data.paletizadores.slice(0, 15).map((p, idx) => (
              <View key={p.id} style={idx < 3 ? styles.tableRowTop3 : (idx % 2 === 0 ? styles.tableRow : styles.tableRowAlt)}>
                <Text style={[styles.cell, styles.cellRank, styles.trophy]}>{getRank(idx)}</Text>
                <Text style={[styles.cell, styles.cellNombre, { fontWeight: idx < 3 ? 'bold' : 'normal' }]}>{p.nombre}</Text>
                <Text style={[styles.cell, styles.cellNum, { fontWeight: 'bold' }]}>{p.pallets_armados}</Text>
                <Text style={[styles.cell, styles.cellNum]}>{p.vuelos_trabajados}</Text>
                <Text style={[styles.cell, styles.cellPeso]}>{(p.peso_total || 0).toLocaleString()}</Text>
                <Text style={[styles.cell, styles.cellNum]}>{(p.piezas_total || 0).toLocaleString()}</Text>
              </View>
            ))}
          </View>
        </View>

        {/* Distribuidores */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>🚚 Distribuidores</Text>
          <View style={styles.table}>
            <View style={styles.tableHeader}>
              <Text style={[styles.cell, styles.cellRank, styles.headerCell]}>#</Text>
              <Text style={[styles.cell, styles.cellNombre, styles.headerCell]}>NOMBRE</Text>
              <Text style={[styles.cell, styles.cellNum, styles.headerCell]}>PALLETS</Text>
              <Text style={[styles.cell, styles.cellNum, styles.headerCell]}>VUELOS</Text>
              <Text style={[styles.cell, styles.cellPeso, styles.headerCell]}>PESO (kg)</Text>
            </View>
            {data.distribuidores.slice(0, 15).map((d, idx) => (
              <View key={d.id} style={idx < 3 ? styles.tableRowTop3 : (idx % 2 === 0 ? styles.tableRow : styles.tableRowAlt)}>
                <Text style={[styles.cell, styles.cellRank, styles.trophy]}>{getRank(idx)}</Text>
                <Text style={[styles.cell, styles.cellNombre, { fontWeight: idx < 3 ? 'bold' : 'normal' }]}>{d.nombre}</Text>
                <Text style={[styles.cell, styles.cellNum, { fontWeight: 'bold' }]}>{d.pallets_distribuidos}</Text>
                <Text style={[styles.cell, styles.cellNum]}>{d.vuelos_trabajados}</Text>
                <Text style={[styles.cell, styles.cellPeso]}>{(d.peso_total || 0).toLocaleString()}</Text>
              </View>
            ))}
          </View>
        </View>

        <View style={styles.footer}>
          <Text>Generado: {new Date().toLocaleString()}</Text>
          <Text>Pallet Control - Sistema de Gestión de Carga</Text>
        </View>
      </Page>
    </Document>
  );
};

export default ReporteProductividadPDF;

